import { apiRequest } from './apiRequest';
import type { InviteValidation } from '../../types/api/invites';

export async function validateInviteToken(token: string): Promise<InviteValidation> {
  const searchParams = new URLSearchParams({ token: token || '' });
  return await apiRequest<InviteValidation>(
    `/api/invites/validate?${searchParams.toString()}`,
    { method: 'GET' },
  );
}
